import { GetHiringStagesDocument, GetHiringStagesQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type HiringStage = GetHiringStagesQuery['ats']['hiringStagesConnection']['nodes'][number]

export const useHiringStages = () => {
  const { data, loading } = useQuery(GetHiringStagesDocument, {})

  const nodes = data?.ats.hiringStagesConnection.nodes

  return {
    loading,
    hiringStages: nodes ? (nodes as HiringStage[]) : [],
  }
}
